import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import {
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const useGetFilterAllOutgoingInvoices = (orderNumber: string) => {
    return useRequest<OutgoingInvoice[]>({
        key: RequestKeys.filterAllOutgoingInvoices,
        params: {
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requests.filterAllOutgoingInvoices, (promise) => {
            return promise.then((resp) => {
                return resp?.data?.items
            })
        }),
        enabled: Boolean(orderNumber),
    })
}

export default useGetFilterAllOutgoingInvoices
